export default "__VITE_ASSET__Bt3mN76$__"